import * as React from 'react'

function IconLeaf4(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={66}
      height={47}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M54.47 43.42L13.13 12.003l52.106 25.644S51.013-14.08.544 4.501c.004-.017 8.698 54.433 53.926 38.92z"
        fill="#F4BA27"
      />
    </svg>
  )
}

export default IconLeaf4
